'use es6';

import { fromJS, Map as ImmutableMap, Record } from 'immutable';
import { RequestStatus } from '../constants/base';
const DEFAULTS = {
  data: ImmutableMap(),
  status: RequestStatus.UNINITIALIZED
};
class HubDbTable extends Record(DEFAULTS) {
  static fromJS(data) {
    return new HubDbTable({
      data: fromJS(data),
      status: RequestStatus.SUCCEEDED
    });
  }
}
export default HubDbTable;